enum BlockReason {
  UNDER_15 = 'UNDER_15',
  UNDER_18 = 'UNDER_18',
  SAFETY_PROHIBITED_MINOR = 'SAFETY_PROHIBITED_MINOR',
  ALAND_RESIDENT = 'ALAND_RESIDENT',
  INVALID_MUNICIPALITY = 'INVALID_MUNICIPALITY',
  FOREIGN_MUNICIPALITY = 'FOREIGN_MUNICIPALITY',
  EIDAS_AUTHENTICATION = 'EIDAS_AUTHENTICATION',
  MARRIED = 'MARRIED',
  IN_REGISTERED_PARTNERSHIP = 'IN_REGISTERED_PARTNERSHIP',
}

export default BlockReason
